// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1NNXA","sendOtp":"AuthorizeToLogin_sendOtp__17ZN3"};